export const SubscriptionTier = {
  OneMonth: 2,
  OneYear: 1,
} as const

export type SubscriptionTier =
  (typeof SubscriptionTier)[keyof typeof SubscriptionTier]

export interface Subscription {
  startTime: bigint
  expiryTime: bigint
  tier: SubscriptionTier
  exists: boolean
}

export interface Vault {
  id: bigint
  benefactor: `0x${string}`
  beneficiary: `0x${string}`
  cid: string
  encryptionHash: `0x${string}`
  countdownDuration: bigint
  countdownStartTime: bigint
  lastResetTime: bigint
  isCountdownActive: boolean
  exists: boolean
}

export interface VaultDecryptionInfo {
  cid: string
  encryptionHash: `0x${string}`
}

export interface PricingInfo {
  oneMonthPrice: bigint
  oneYearPrice: bigint
}

export interface TokenInfo {
  address: `0x${string}`
  symbol: string
  name: string
  decimals: number
}

export interface ContractConfig {
  address: `0x${string}`
  chainId: number
}

export interface CreateVaultParams {
  cid: string
  encryptionHash: `0x${string}`
  beneficiary: `0x${string}`
  countdownMinutes: bigint
}

export interface ContractWriteResult {
  hash: `0x${string}`
  /** Present for createVault when the receipt includes a VaultCreated log. */
  vaultId?: bigint
}
